export default __webpack_public_path__ + "static/media/hidden.1c08ddfe.jpg";